import React, { useState } from 'react'

import { selectStacks } from 'app-redux/deck/selectors'
import { useAppSelector } from 'app-redux/hooks'

import PhatDropdown from 'components/formElements/PhatDropdown'
import ImageCard from 'components/card/deckCards/imageCard'
import StackWrapper from 'components/deckPage/dragAndDrop/StackWrapper'

import styles from './pinnedCategory.module.scss'

const PinnedCategory = () => {
  const { mainDeck, sideDeck } = useAppSelector(selectStacks)
  const disableMargins = useAppSelector(state => state.cacheables.disableMargins)

  const mergedStacks = [...sideDeck, ...mainDeck]

  if (!sideDeck.find(stack => stack.name === 'Maybeboard'))
    mergedStacks.push({
      name: 'Maybeboard',
      cardIds: [],
      includedInDeck: false,
      price: 0,
      isPremier: false,
      includedInPrice: true,
      quantity: 0,
      mdfcQuantity: 0,
    })

  const defaultStack = 'Maybeboard'

  const [selectedStack, setSelectedStack] = useState(defaultStack)

  const stack = mergedStacks.find(s => s.name === selectedStack)

  return (
    <div className={`${styles.container} ${disableMargins ? styles.disableMargins : ''}`}>
      <PhatDropdown
        triggerWrapperClassName={styles.dropdown}
        value={selectedStack}
        options={mergedStacks.map(stack => ({
          label: `${stack.name} (${stack.quantity})`,
          id: stack.name,
          onClick: () => setSelectedStack(stack.name),
        }))}
      />

      {stack && (
        <StackWrapper id="brewing-container" name={selectedStack} className={styles.stackWrapper}>
          <div className={styles.scrollContainer}>
            {stack.cardIds.map(cardId => (
              <ImageCard
                hidePrices
                stackName={stack.name}
                key={cardId}
                cardId={cardId}
                className={styles.card}
                basicCardClass={styles.basicCard}
                wrapperClassName={styles.wrapperClassName}
              />
            ))}
          </div>
        </StackWrapper>
      )}
    </div>
  )
}

export default PinnedCategory
